export class GetCarnetNoRequest {
    body: GetCarnetNoBody = new GetCarnetNoBody();
}

export class GetCarnetNoBody {
    ProcessName: string = "DC Community Portal SR Process Wrapper WF";
    DCMethod: string = "GET_ATACARNET_DETAILS";
    DCLoginName: string = "";
    DCLanguage: string = "ENU";
    DCIncomingHierarchy: DCIncomingHierarchy = new DCIncomingHierarchy();
}

export class DCIncomingHierarchy {
    MessageId: string = "";
    IntObjectName: string = "DC Community Portal ATA SR IO";
    MessageType: string = "Integration Object";
    IntObjectFormat: string = "Siebel Hierarchical";
    "ListOfDC Community Portal ATA SR IO": ListOfDCCommunityPortalATASRIO = new ListOfDCCommunityPortalATASRIO();
}

export class ListOfDCCommunityPortalATASRIO {
    "DC Community Portal ATA SR": DCCommunityPortalATASR = new DCCommunityPortalATASR();
}

export class DCCommunityPortalATASR {
    CSN: string = "";
    "SR Type": string = "";
    "Sub Type": string = "";
}
